import Vue from 'vue'

const state = {
  location: {},
  locations: []
}

const mutations = {
  SET_LOCATION ({ commit }, value) {
    state.location = value
  },
  SET_LOCATIONS ({ commit }, value) {
    state.locations = value || []
  },
  ADD_LOCATION ({ commit }, value) {
    state.locations.push(value)
  },
  REMOVE_LOCATION ({ commit }, value) {
    state.locations.splice(state.locations.indexOf(value), 1)
  }
}

const actions = {
  getLocations ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}location/getbyuser`)
        .then(response => {
          commit('SET_LOCATIONS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createLocation ({ commit }, name) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}location/create`, {
        Name: name,
        TimeZone: 'US Eastern Standard Time'
      })
        .then(response => {
          if (response.data > 0) {
            commit('ADD_LOCATION', { ID: response.data, Name: name })
            resolve(response)
          } else {
            reject(new Error('Location already exists.'))
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateLocation ({ commit }, location) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}location/update`, {
        ID: location.ID,
        Name: location.Name
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteLocation ({ commit }, location) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}location/delete`, {
        ID: location.ID
      })
        .then(response => {
          if (response.data) {
            commit('REMOVE_LOCATION', location)
            resolve(response)
          } else {
            reject(new Error('Something went wrong.'))
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const getters = {
  location () {
    return state.location
  },
  locations () {
    return state.locations
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/locations.js